import React, { useEffect, useState } from "react";
import Navbar from "../components/partial/Navbar";
import Footer from "../components/partial/Footer";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link, useParams } from "react-router-dom";
import { useGetPackageDetailsQuery } from "../../redux/API/PackageApi";
import { ImgUrl, packageImgUrl } from "../../constant";
import {
  useCreateEnquiryApiMutation,
  useCreateEnquiryApiQuery,
} from "../../redux/API/ContactApi";
import EnquiryForm from "../components/form/Enquiryform";

const PackageDetail = () => {
    const { name } = useParams();
    const { data: packageData } = useGetPackageDetailsQuery(name);
    const [createEnquiry, isLoading] = useCreateEnquiryApiMutation();
    const [activeTab, setActiveTab] = useState("overview");
    const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    travellers: 1,
    adults: 0,
    children: 0,
    infants: 0,
    message: "",
    packageId: packageData?.data?._id
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleIncrement = (field) => {
    setFormData((prev) => ({ ...prev, [field]: prev[field] + 1 }));
  };

  const handleDecrement = (field) => {
    if (formData[field] > 0) {
      setFormData((prev) => ({ ...prev, [field]: prev[field] - 1 }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await createEnquiry(formData).unwrap();
      console.log("Enquiry Submitted Successfully:", response);
      alert("Enquiry submitted successfully!");
    } catch (error) {
      console.error("Error submitting enquiry:", error);
      alert("Failed to submit enquiry.");
    }
  };

  useEffect(() => {
    AOS.init({
      delay: 100,
      duration: 600,
      easing: "ease",
      once: false,
      mirror: false,
    });
  }, []);

  const packageDetails = packageData?.data;
  function createMarkup(content) {
    const sanitizedContent = content?.replace(/<p>&nbsp;<\/p>*>/g, "");
    return { __html: sanitizedContent };
  }

  return (
    <>
      <Navbar />

      <div className="hero_banner">
        <div
          id="carouselExampleAutoplaying"
          class="carousel slide h-100"
          data-bs-ride="carousel"
        >
          <div class="carousel-inner h-100">
            {packageData?.data?.images[0]?.map((img, index) => (
              <div
                className={`carousel-item h-100 ${index === 0 ? "active" : ""}`}
                key={index}
              >
                <img
                  src={`${ImgUrl}${packageImgUrl}${img}`}
                  className="d-block w-100"
                  alt="..."
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <section className="container mt-md-5 mt-sm-4">
        <div className="row">
          <div className="col-lg-9">
            <h2>{packageDetails?.name}</h2>
            <div className="d-flex  flex-wrap card1">
              <h6 className="fs-6 fw-semibold detail">
                <span
                  className="text-decoration-none me-lg-4 me-3 pb-lg-2 pb-md-2 pb-sm-1"
                  style={{
                    cursor: "pointer",
                    fontSize: "14px",
                    borderBottom: activeTab === "overview" ? "3px solid black" : "none",
                    paddingBottom: activeTab === "overview" ? "0.5rem" : "0",
                  }}
                  onClick={() => {
                    document.getElementById("overview")?.scrollIntoView({ behavior: "smooth" });
                    setActiveTab("overview"); // Step 2: Update state on click
                  }}
                >
                  Overview
                </span>
              </h6>

              <h6 className="me-lg-4 me-3 fs-6 fw-semibold detail1 ">
                <span
                  className="text-decoration-none"
                  style={{
                    cursor: "pointer",
                    fontSize: "14px",
                    borderBottom: activeTab === "itenery" ? "3px solid black" : "none",
                    paddingBottom: activeTab === "itenery" ? "0.5rem" : "0",
                  }}
                  onClick={() => {
                    document.getElementById("itenery")?.scrollIntoView({ behavior: "smooth" });
                    setActiveTab("itenery");
                  }}
                >
                  Itinerary
                </span>
              </h6>

              <h6 className="me-lg-4 me-3 fs-6 fw-semibold detail1">
                <span
                  className="text-decoration-none"
                  style={{
                    cursor: "pointer",
                    fontSize: "14px",
                    borderBottom: activeTab === "inclusion" ? "3px solid black" : "none",
                    paddingBottom: activeTab === "inclusion" ? "0.5rem" : "0",
                  }}
                  onClick={() => {
                    document.getElementById("inclusion")?.scrollIntoView({ behavior: "smooth" });
                    setActiveTab("inclusion");
                  }}
                >
                  Inclusions
                </span>
              </h6>

              <h6 className="me-lg-4 me-3 fs-6 fw-semibold detail1">
                <span
                  className="text-decoration-none"
                  style={{
                    cursor: "pointer",
                    fontSize: "14px",
                    borderBottom: activeTab === "exclusion" ? "3px solid black" : "none",
                    paddingBottom: activeTab === "exclusion" ? "0.5rem" : "0",
                  }}
                  onClick={() => {
                    document.getElementById("exclusion")?.scrollIntoView({ behavior: "smooth" });
                    setActiveTab("exclusion");
                  }}
                >
                  Exclusions
                </span>
              </h6>

              <h6 className="me-lg-4 me-3 fs-6 fw-semibold detail1">
                <span
                  className="text-decoration-none"
                  style={{
                    cursor: "pointer",
                    fontSize: "14px",
                    borderBottom: activeTab === "other-details" ? "3px solid black" : "none",
                    paddingBottom: activeTab === "other-details" ? "0.5rem" : "0",
                  }}
                  onClick={() => {
                    document.getElementById("other-details")?.scrollIntoView({ behavior: "smooth" });
                    setActiveTab("other-details");
                  }}
                >
                  Other Details
                </span>
              </h6>
            </div>
            
            <div className="card p-3 mb-3 mt-3" id="overview">
              <h4>Overview</h4>
              <div
                dangerouslySetInnerHTML={createMarkup(packageDetails?.overview)}
              />
            </div>
            <div className="card p-3 mb-3" id="itenery">
              <h4>Itinerary</h4>
              <div
                dangerouslySetInnerHTML={{ __html: packageDetails?.itinerary }}
              />
            </div>

            <div className="card p-3 mb-3" id="inclusion">
              <h4>Inclusions</h4>
              <div
                dangerouslySetInnerHTML={{ __html: packageDetails?.inclusion }}
              />
            </div>

            <div className="card p-3 mb-3 " id="exclusion">
              <h4>Exclusions</h4>
              <div
                dangerouslySetInnerHTML={{ __html: packageDetails?.exclusion }}
              />
            </div>

            <div className="card p-3" id="other-details">
              <h4>Other Detail</h4>
              <div className="d-flex align-items-center">
                <div>
                  <h5 className="mb-0">Duration</h5>
                  <p>{packageDetails?.days} Days</p>
                </div>

                <div className="ms-5">
                  <h5 className="mb-0">Price</h5>
                  <p>₹{packageDetails?.price}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 mt-lg-5 mt-3 pt-2 pt-lg-5" >
            <EnquiryForm
              pid={packageData?.data?._id}
            />
          </div>

        </div>
      </section>

      <Footer />
    </>
  );
};

export default PackageDetail;
